// change mega-menu trigger to 'hover' instead of 'click'
(function(){
  let items = document.querySelectorAll('.header__inline-menu details');
  items.forEach(item => {
    item.addEventListener('mouseover', () => {
      item.setAttribute('open', true);
      // item.querySelector('.mega-menu__content').addEventListener('mouseleave', () => {
      //   item.removeAttribute('open');
      // });
      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
    });
  });
})();

// product page media gallery thumbnails scroll on click
(function () {
  var productSlideshowThumbs = document.querySelectorAll('.product__media-wrapper .thumbnail-slider .thumbnail');
  for (const element of productSlideshowThumbs) {
    element.addEventListener('click', function(){
        this.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
    });
  }
})();

// tabs
(function(){
  let tabLinks = document.querySelectorAll('.tab-link');
  let tabs = document.querySelectorAll('.tab');
  for (const link of tabLinks) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      if (link.classList.contains('active')) return;

      const tabIDSelector = link.getAttribute('href');

      for (const tab of tabs) {
        tab.style.display = 'none';
      }
      for (const l of tabLinks) {
        l.classList.remove('active');
      }

      document.querySelector(tabIDSelector).style.display = 'block';
      e.currentTarget.classList.add('active');
    });
  }
})();

// popup duplicate close button
(function(){
  var dupBtn = document.querySelector('.product-popup-modal__toggle-2');
  if (dupBtn) {
    dupBtn.addEventListener('click', function(e) {
      document.querySelector('.product-popup-modal__toggle').click();
    });
  }
})();

// size guide page front-back image switchers
(function(){
  var btns = document.querySelectorAll('.size-guide-slider__photo-buttons button');
  for (const btn of btns) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (btn.classList.contains('active')) return;

      var secondImg = e.currentTarget.closest('.size-guide-slider__photo').querySelector('img + img');

      if (e.currentTarget.name == 'back') {
        secondImg.classList.remove('hidden');
      } else {
        secondImg.classList.add('hidden');
      }
      e.currentTarget.closest('.size-guide-slider__photo').querySelector('button.active').classList.remove('active');
      e.currentTarget.classList.add('active');
    });
  }
})();

// customer account pages
(function(){
  var openContextMenuBtns = document.querySelectorAll('.address__menu-button');
  for (const btn of openContextMenuBtns) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.closest('.address__menu').querySelector('.address__menu-list').classList.toggle('hidden');
    });
  }

  var editAddressBtns = document.querySelectorAll('.address__edit-button');
  for (const btn of editAddressBtns) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.closest('.address__card').querySelector('.address-edit-form-button').click();
    });
  }

  var removeAddressBtns = document.querySelectorAll('.address__remove-button');
  for (const btn of removeAddressBtns) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.closest('.address__card').querySelector('.address-remove-form-button').click();
    });
  }

  var expandOrderItemBtns = document.querySelectorAll('.order-detail-button');
  for (const btn of expandOrderItemBtns) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.closest('.order-history__item').classList.toggle('expanded');
    });
  }
})();

// product card images carousel
(function () {
  var carouselBtns = document.querySelectorAll('.card__image-buttons button');
  for (const btn of carouselBtns) {
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var imagesContainer = btn.closest('.card__inner').querySelector('.card__media .media');
      if (btn.name == 'media-next') {
        var firstImage = imagesContainer.querySelector('img:first-child');
        imagesContainer.append(firstImage);
      } else {
        var lastImage = imagesContainer.querySelector('img:last-child');
        imagesContainer.prepend(lastImage);
      }
    });
  }
})();

// faq accordions
(function () {
  var faqAccordions = document.querySelectorAll('.faq-main [id^="Details-"] summary');
  faqAccordions.forEach((summary) => {
    summary.addEventListener('click', (event) => {
      var activeSummary = document.querySelector('.faq-main [id^="Details-"] summary[aria-expanded="true"]');
      // debugger;
      if (activeSummary && event.currentTarget != activeSummary) {
        activeSummary.parentNode.removeAttribute('open')
        activeSummary.setAttribute('aria-expanded', false);
      }
    });
  })
})();